<template>
  <div v-loading="listLoading" element-loading-text="拼命加载中...">
    <div class="filter" style="margin-top:-30px;">
      <el-tabs type="border-card" class="card-tab">
        <el-tab-pane label="兼职签约查询">
          <el-form :model="params" :inline="true" label-width="200px" class="formInline" size="mini">
            <div class="slide-wrap" style="height: auto;">
              <el-form-item label="人员编码">
                <el-input v-model="params.empCode" placeholder="请输入人员编码..."></el-input>
              </el-form-item>
              <el-form-item label="姓名">
                <el-input v-model="params.name" placeholder="请输入姓名..."></el-input>
              </el-form-item>
              <el-form-item label="身份证号码">
                <el-input v-model="params.idCard" placeholder="请输入身份证号码..."></el-input>
              </el-form-item>
              <el-form-item label="是否签约">
                <el-select v-model="params.signed" filterable placeholder="请选择是否签约..." clearable>
                  <el-option label="是" :value="1"></el-option>
                  <el-option label="否" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="签约平台">
                <el-select v-model="params.serviceSupplier" filterable placeholder="请选择签约平台..." clearable>
                  <el-option :label="item" :value="item" v-for="item in serviceSuppliers"
                           :key="item"></el-option>
                  <!-- <el-option label="薪太软" value="薪太软"></el-option>
                  <el-option label="众简" value="众简"></el-option> -->
                </el-select>
              </el-form-item>
              <el-form-item label="签约公司">
                <el-select v-model="params.company" value-key="code" filterable placeholder="请选择签约公司..." clearable>
                  <el-option v-for="item in companiesAll" :label="item.name" :value="item.code" :key='item'></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="任务激活月份">
                <el-date-picker value-format="yyyy-MM" v-model="params.activateBegin" type="month"></el-date-picker>
                -
                <el-date-picker value-format="yyyy-MM" v-model="params.activateEnd" type="month"></el-date-picker>
              </el-form-item>
            </div>
            <hr style="margin-bottom: 9px;">
            <div class="slide-btns clearfix">
              <el-form-item>
                <el-button type="text" class="reset-btn" @click="resetParams">清空</el-button>
                <el-button class="search-btn" @click="searchData">筛选</el-button>
                <el-button class="search-btn" @click="exportData">导出</el-button>
              </el-form-item>
            </div>
          </el-form>
        </el-tab-pane>
      </el-tabs>
      <div class="tableBody">
        <el-table class="limitManagerTable table-expand" style="width: 100%;" size="small" border :data="tableData">
          <el-table-column type="index" label="#" align="center"></el-table-column>
          <el-table-column prop="empCode" label="人员编码" align="center"></el-table-column>
          <el-table-column prop="name" label="姓名" align="center"></el-table-column>
          <el-table-column prop="idCard" label="身份证号码" align="center"></el-table-column>
          <el-table-column prop="mobile" label="手机号码" align="center"></el-table-column>
          <el-table-column prop="openBank" label="开户行" align="center"></el-table-column>
          <el-table-column prop="bankNo" label="银行卡号" align="center"></el-table-column>
          <el-table-column label="银行卡认证状态" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.bankAuth == 1">通过</span>
              <span v-else>失败</span>
            </template>
          </el-table-column>
          <el-table-column label="是否签约" align="center">
            <template slot-scope="scope">
              <span style="color: #1652ff; cursor: pointer;" v-if="scope.row.signed == 1"
                    @click="doShowContractDialog(scope.row.empCode)">是</span>
              <span v-else>否</span>
            </template>
          </el-table-column>
          <el-table-column label="任务激活" align="center">
            <template slot-scope="scope">
              <span style="color: #1652ff; cursor: pointer;" @click="doShowTaskDialog(scope.row.empCode)">查看</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination class="pagination table-pagination" @size-change="handleSizeChange"
                       @current-change="handleCurrentChange" :current-page="params.pageNo"
                       :page-sizes="[10, 20, 50, 100]" :page-size="params.pageSize"
                       layout="slot,sizes, total,  prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
      <!--签约合同弹出框-->
      <el-dialog class="dialog" title="签约合同" :visible.sync="showContractDialog" width="70%" center>
        <div class="tableBody">
          <el-table class="table-expand" style="width: 100%;" size="small" border :data="contractTableData">
            <el-table-column type="index" label="#" align="center"/>
            <el-table-column prop="serviceSupplier" label="签约平台" align="center"/>
            <el-table-column prop="companyName" label="公司名称" align="center"/>
            <el-table-column prop="taskName" label="任务名称" align="center"/>
            <el-table-column prop="supplierName" label="供应商名称" align="center"/>
            <el-table-column prop="serviceNm" label="服务商名称" align="center"/>
            <el-table-column prop="signTime" label="签约时间" align="center"/>
            <el-table-column prop="beginDate" label="合同开始日期" align="center"/>
            <el-table-column prop="endDate" label="合同结束日期" align="center"/>
          </el-table>
          <el-pagination class="pagination table-pagination"
                         @size-change="handleContractSizeChange"
                         @current-change="handleContractCurrentChange"
                         :current-page="contractParams.pageNo"
                         :page-sizes="[10, 20, 50, 100]" :page-size="contractParams.pageSize"
                         layout="slot,sizes, total,  prev, pager, next, jumper" :total="contractTotal">
          </el-pagination>
        </div>
      </el-dialog>

      <!--任务激活弹出框-->
      <el-dialog class="dialog" title="任务激活" :visible.sync="showTaskDialog" width="70%" center>
        <div class="tableBody">
          <el-table class="table-expand" style="width: 100%;" size="small" border :data="taskTableData">
            <el-table-column type="index" label="#" align="center"/>
            <el-table-column prop="taskName" label="任务名称" align="center"/>
            <el-table-column prop="supplierName" label="供应商名称" align="center"/>
            <el-table-column prop="serviceNm" label="服务商名称" align="center"/>
            <el-table-column prop="activateMonth" label="任务激活月份" align="center"/>
          </el-table>
          <el-pagination class="pagination table-pagination"
                         @size-change="handleTaskSizeChange"
                         @current-change="handleTaskCurrentChange"
                         :current-page="taskParams.pageNo"
                         :page-sizes="[10, 20, 50, 100]" :page-size="taskParams.pageSize"
                         layout="slot,sizes, total,  prev, pager, next, jumper" :total="taskTotal">
          </el-pagination>
        </div>
      </el-dialog>

    </div>
  </div>
</template>

<script>
  import utils from '../../common/js/util.js'

  export default {
    data() {
      return {
        params: {
          empCode: null,
          name: null,
          idCard: null,
          signed: null,
          serviceSupplier: null,
          company: null,
          activateBegin: null,
          activateEnd: null,
          pageSize: null,
          pageNo: null
        },
        total: null,
        tableData: [],
        listLoading: false,
        companiesAll: [],
        showContractDialog: false,
        contractParams: {
          empCode: null,
          pageSize: null,
          pageNo: null
        },
        contractTotal: null,
        contractTableData: [],
        showTaskDialog: false,
        taskParams: {
          empCode: null,
          pageSize: null,
          pageNo: null
        },
        taskTotal: null,
        taskTableData: [],
        serviceSuppliers: []
      }
    },
    mounted() {
      this.searchCompaniesAll();
      this.getData();
      this.getServiceSuppliers();
    },
    methods: {
      // 翻页
      handleSizeChange(value) {
        this.params.pageSize = value;
        this.getData();
      },
      handleCurrentChange(value) {
        this.params.pageNo = value;
        this.getData();
      },
      /**
       * 查询公司下拉列表
       */
      searchCompaniesAll() {
        this.$http({
          method: 'GET',
          url: '/rest/superviseContract/virtual-project/companies'
        }).then(res => {
          this.companiesAll = res.data.data
        }).catch(err => {
        })
      },
      getData() {
        this.listLoading = true;
        this.$http({
          method: 'get',
          url: '/rest/superviseContract/supervises',
          params: this.params
        }).then(res => {
          if (res.data && res.data.code == '0') {
            var data = res.data.data;
            this.total = data.totalItemsCount;
            this.tableData = data.items;
          }
          this.listLoading = false;
        }).catch(err => {
          console.log(err);
          this.listLoading = false;
        });
      },
      resetParams() {
        this.params.empCode = null;
        this.params.name = null;
        this.params.idCard = null;
        this.params.signed = null;
        this.params.company = null;
        this.params.activateBegin = null;
        this.params.activateEnd = null;
      },
      searchData() {
        this.params.pageNo = 1;
        this.getData();
      },
      exportData() {
        this.listLoading = true;
        this.$http({
          method: 'GET',
          url: '/rest/superviseContract/supervises/export',
          params: this.params,
        }).then(res => {
          if (res.data && res.data.status == 200) {
            this.listLoading = false;
            location.href = utils.returnUrlHead() + res.data.data;
          } else {
            this.listLoading = false;
            this.$alert(res.data.message);
          }
        }).catch(error => {
          console.log(error)
          this.listLoading = false;
          this.$alert("导出错误，请联系管理员！");
        });
      },
      // 翻页
      handleContractSizeChange(value) {
        this.contractParams.pageSize = value;
        this.getContractData();
      },
      handleContractCurrentChange(value) {
        this.contractParams.pageNo = value;
        this.getContractData();
      },
      doShowContractDialog(empCode) {
        this.contractParams.empCode = empCode;
        this.showContractDialog = true;
        this.getContractData();
      },
      getContractData() {
        this.listLoading = true;
        this.$http({
          method: 'get',
          url: '/rest/superviseContract/supervise/contract-recodes',
          params: this.contractParams
        }).then(res => {
          if (res.data && res.data.code == '0') {
            var data = res.data.data;
            this.contractTotal = data.totalItemsCount;
            this.contractTableData = data.items;
          }
          this.listLoading = false;
        }).catch(err => {
          console.log(err);
          this.listLoading = false;
        });
      },

      // 翻页
      handleTaskSizeChange(value) {
        this.taskParams.pageSize = value;
        this.getTaskData();
      },
      handleTaskCurrentChange(value) {
        this.taskParams.pageNo = value;
        this.getTaskData();
      },
      doShowTaskDialog(empCode) {
        this.taskParams.empCode = empCode;
        this.showTaskDialog = true;
        this.getTaskData();
      },
      getTaskData() {
        this.listLoading = true;
        this.$http({
          method: 'get',
          url: '/rest/superviseContract/supervise/contracts',
          params: this.taskParams
        }).then(res => {
          if (res.data && res.data.code == '0') {
            var data = res.data.data;
            this.taskTotal = data.totalItemsCount;
            this.taskTableData = data.items;
          }
          this.listLoading = false;
        }).catch(err => {
          console.log(err);
          this.listLoading = false;
        });
      },
      getServiceSuppliers() {
        this.$http({
          method: 'GET',
          url: '/rest/JiangYiJoint/getServiceSuppliers',
          
        }).then(res => {
          this.serviceSuppliers = res.data
        }).catch(err => {
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/personnelCenter/supervise.vue